import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {update_s_chars_mods} from "../_signals/s_chars_mods";
import {ICharMod} from "../_interfaces/ICharMod";
import {CharacterModsAdd} from "../_payload/CharacterModsAdd";
import {CharacterModsDelete} from "../_payload/CharacterModsDelete";
import {CharacterModsUpdate} from "../_payload/CharacterModsUpdate";
import {CharacterModsSourceDelete} from "../_payload/CharacterModsSourceDelete";
import {s_app_sl} from "../_signals/s_app";

export const ModsGet = (rid: string) => {
    fetch(apiAddress + "/char/mods/" + rid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                if (data.hasOwnProperty('result')) {
                    console.log('getSCharsData mods', data.result);
                    update_s_chars_mods(data.result as ICharMod[])
                }
            }
        )
}

export const ModsAdd = (cid: string, rid:string,mods: ICharMod[]) => {
    const post: CharacterModsAdd = {cid: cid, rid:rid,mods: mods, sl: s_app_sl.value}
    fetch(apiAddress + "/char/mods/", createOptions('POST', post))
        .then((res) => res.json())
        .then((data) => console.log('ModsAdd result', data))
        .catch((reason => console.log('ModsAdd create catch', reason)))
}

export const ModsDelete = (cid: string, rid:string,removeModIds: string[]) => {
    const todelete: CharacterModsDelete = {cid: cid,rid:rid, mods: removeModIds, sl: s_app_sl.value}
    fetch(apiAddress + "/char/mods/", createOptions('DELETE', todelete))
        .then((res) => res.json())
        .then((data) => console.log('ModsAdd result', data))
        .catch((reason => console.log('ModDelete delete catch', reason)))
}

export const ModsUpdate = (cid: string, rid:string,mods: ICharMod[]) => {
    const update: CharacterModsUpdate = {cid: cid, rid:rid,mods: mods, sl: s_app_sl.value}
    fetch(apiAddress + "/char/mods/", createOptions('POST', update))
        .then((res) => res.json())
        .then((data) => console.log('ModsAdd result', data))
        .catch((reason => console.log('Mods Update update catch', reason)))
}

export const ModsSourceAdd = (cid: string, rid:string,source: string, sourceid: string) => {
    const addSource: CharacterModsSourceDelete = {cid: cid, rid:rid,source: source, sl: s_app_sl.value, sourceid: sourceid}
    fetch(apiAddress + "/char/mods/sourceadd/", createOptions('POST', addSource))
        .then((res) => res.json())
        .then((data) => console.log('ModsAdd result', data))
        .catch((reason => console.log('modsource create catch', reason)))

}

export const ModsSourceDelete = (cid: string, rid:string,source: string, sourceid: string) => {
    const remove: CharacterModsSourceDelete = {cid: cid, rid:rid,source: source, sl: s_app_sl.value, sourceid: sourceid}
    fetch(apiAddress + "/char/mods/sourcedelete/", createOptions('POST', remove))
        .then((res) => res.json())
        .then((data) => console.log('ModsAdd result', data))
        .catch((reason => console.log('modsource remove catch', reason)))

}